import React, { useMemo } from 'react';
import EcosystemFrame from '../three/EcosystemFrame';
import { deriveFleet } from '../three/fleetState';
import { portfolioFixture } from '../../data/portfolioFixture';
import './portfolio.css';

// A private-equity portfolio as one fleet, under the simulator: twelve
// companies, each a workspace platform with its instances, the control
// plane behind them. Synthetic — the real view reads the firm's
// organizations. The figure is the in-page fleet stage; `enter room` opens
// the same fixture as a walkable room at /concepts/portfolio/room
// (pages/room/PortfolioRoom.js, lazy — the room pulls in three.js).
export default function PortfolioFleet() {
  const data = useMemo(() => portfolioFixture(), []);
  return (
    <div className="as-screen pf-fleet">
      <EcosystemFrame data={data} derive={deriveFleet} scene="fleet" aspect="16 / 8" roomHref="/concepts/portfolio/room" caption />
      <div className="as-foot">
        <span className="as-foot-chip">synthetic data</span>
        <span>Twelve companies, {data.apps.length} instances. Each company is its own organization on the platform; the firm's seat reads them as one fleet. Drag to orbit · enter room to walk it.</span>
      </div>
    </div>
  );
}
